// extracted by mini-css-extract-plugin
export default {"statusTag":"card-status-tag_statusTag__f+M4p","active":"card-status-tag_active__qbmwL","inactive":"card-status-tag_inactive__RJXM9","label":"card-status-tag_label__08ceX"};